import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithContent,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TextareaLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_13_1_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  Header1("typography_3"),
  // TODO: src/static/activity/13-1-A/0_ko.png 에 "결과로서의 행동" 이미지 추가 필요. 현재는 mock placeholder.
  // 배포 임시: mock 이미지 주석 처리, text instruction 만 노출
  // InstructionWithImage("typography_4", "0"),
  Instruction("typography_4"),
  Instruction("typography_5"),

  InstructionWithButtonGroup(
    "typography_6",
    [
      { text: "하던 일을 멈추고 자리에 굳어버린다. (정지)" },
      { text: "나쁜 기분을 떨치기 위해 노래를 듣는다. (도피)" },
      { text: "거친 행동을 하고 싶은 충동을 느낀다. (투쟁)" },
    ],
    { id: "stress_response", vertical: true }
  ),

  Instruction("typography_7"),
  Instruction("typography_8"),
  Instruction("typography_9"),
  Instruction("typography_10"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    [
      ButtonGroup(
        [
          { text: "A. 마음이 너무 불안해 '심호흡을 크게 세 번 반복함'" },
          { text: "B. 분노가 치밀어 올라 '명상 영상을 찾아 들음'" },
          { text: "C. 직장 상사에게 혼이 난 뒤, '화장실로 숨어버림'" },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_13"),

  Header1("typography_14"),
  Instruction("typography_15"),

  InstructionWithContent(`typography_16`, [
    [
      ButtonGroup(
        [
          { text: "A. 가슴이 답답하고 두근거려서 침대에 누워버림" },
          { text: "B. 얼굴이 붉게 달아오르고 손이 심하게 떨려서 당황함" },
          { text: "C. 아무 말도 하지 못한 채 전화를 끊음" },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_17"),

  InstructionWithContent(`typography_18`, [
    [
      ButtonGroup(
        [
          { text: "A. 가슴이 심하게 두근거림" },
          { text: "B. 침대에 누워버림" },
          { text: "C. 가슴이 답답해서 숨을 쉬기가 힘들었음" },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_19"),

  Header1("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),

  Header1("typography_23"),
  Instruction("typography_24"),
  InstructionWithContent(`typography_25`, [
    ...LineWithSolidLabel("상황", TextareaLine({ id: "상황" })),
  ]),
  InstructionWithContent(`typography_26`, [
    ...LineWithSolidLabel("생각", TextareaLine({ id: "생각" })),
  ]),
  InstructionWithContent(`typography_27`, [
    ...LineWithSolidLabel("감정", TextareaLine({ id: "감정" })),
  ]),
  InstructionWithContent(`typography_28`, [
    ...LineWithSolidLabel("신체 반응", TextareaLine({ id: "신체 반응" })),
  ]),
  InstructionWithContent(`typography_29`, [
    ...LineWithSolidLabel("행동/충동", TextareaLine({ id: "행동/충동" })),
  ]),
  Instruction("typography_30"),

  ...LastCard,
];
